
export default defineNuxtRouteMiddleware((to) => {
  if(process.client){

    const { isLogged, $state } = useUsuarioStore();
    //const goToHome = () => router.replace("/");
    const goToHome = () => to.path = "/";
    
    if( isLogged() ){
      if( to.path!="/" ){
        if( to.path!="/usuarios/alterar-meus-dados" && to.path!="/usuarios/alterar-dados-de-acesso" && (! to.meta.module || to.path=="/autenticacao/login" || to.path=="/autenticacao/recuperacao") ){
          navigateTo("/");
        }
        else{
          let mod = to.meta.module;
          if( mod ){
            const config = useRuntimeConfig();
            let usuario = $state.usuario;
            
            let flag = false;
            for(let m of mod.split("|")){
              if( usuario.funcao[ m ] || usuario.funcao[ m+'_aux' ] ){
                flag = flag || true;
              }
            }
            if( ! flag ){
              navigateTo("/");
            }
          }
        }
      }
    }else{
      if(to.path!="/autenticacao/login" && to.path!="/autenticacao/recuperar-acesso" && ! to.path.includes("/autenticacao/trocar-senha") ){
        navigateTo("/autenticacao/login");
      }
    }
  }
});